import {configureStore} from '@reduxjs/toolkit'
import {programReducer} from "../Reducers/ProgramReducer";

export const store = configureStore({
    reducer: {
        data: programReducer,
    },
})
